<template>
  <div>
    <van-popup v-model="showFeedBack">
      <div class="feed-back">
        <div class="title" v-if="feedType === 'night'">
          {{ $t("im.紧急问题反馈") }}
        </div>
        <div class="title" v-else>
          {{ $t("im.为了更快解决您的问题") }}
          <br />
          {{ $t("im.请填写您本次来访的基本信息") }}
        </div>
        <p class="chat-roles-small-title">
          {{ $t("im.来访类型") }}<span class="red">*</span>
        </p>
        <div>
          <select v-model="type" class="chat-input chat-roles-reason">
            <option value="">{{ $t("im.请选择来访类型") }}</option>
            <option v-for="item in reason" :key="item.id" :value="item.id">{{
              item.name
            }}</option>
          </select>
        </div>
        <p class="chat-roles-small-title">
          {{ $t("im.问题描述") }}
          <span class="red">*</span>
        </p>
        <div>
          <textarea
            maxlength="200"
            v-model="msg"
            :placeholder="$t('im.questionInfo')"
            class="chat-input chat-role-desc"
            rows="4"
          ></textarea>
        </div>
        <van-button @click="submitFeedBack" class="sub-btn" type="primary">{{
          $t("im.提交")
        }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    reason: {
      type: Array,
      default: () => [],
    },
    feedType: {
      type: String,
      default: "normal",
    },
  },
  data() {
    return {
      type: "",
      msg: "",
      showFeedBack: false,
    };
  },
  watch: {
    showFeedBack(val) {
      if (!val) {
        this.type = "";
        this.msg = "";
      }
    },
  },
  methods: {
    submitFeedBack() {
      if (!this.type) {
        this.$toast(this.$t("im.请选择来访类型"));
        return;
      }
      // 描述不能超过100个字符
      if (this.msg && this.msg.length > 200) {
        this.$toast(this.$t("im.问题描述不能超过200个字符"));
        return;
      }
      this.$emit("submit", { type: this.type, msg: this.msg });
    },
  },
};
</script>

<style lang="less" scoped>
.feed-back {
  padding: 15px;
  width: 290px;
  .title {
    font-size: 17px;
    color: #9c9aa3;
    text-align: center;
  }
  .chat-input {
    display: block;
    width: 100%;
    // height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border-color ease-in-out 0.15s,
      -webkit-box-shadow ease-in-out 0.15s;
    -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    outline: none;
  }
  .chat-role-desc {
    width: 260px;
  }
  .chat-roles-small-title {
    font-size: 12px;
    margin: 10px 0;
    color: #9c9aa3;
  }
  .sub-btn {
    width: 100%;
    margin-top: 50px;
    height: 44px;
    font-size: 16px;
  }
}
</style>
